import { render, staticRenderFns } from "./learningModule.vue?vue&type=template&id=c4681772&scoped=true"
import script from "./learningModule.vue?vue&type=script&lang=js"
export * from "./learningModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4681772",
  null
  
)

export default component.exports